import { useCallback, useState } from 'react';
import { pollWatchlist } from './api';
import { INITIAL_POLL_STATE, type PollState } from './useJobsInbox';

/**
 * Home's "CHECK NOW" affordance (LANE U1, piece (c): "wired to the EXISTING
 * poll endpoint — POST /watchlist/poll — the same call Jobs' 'Check for new
 * jobs' uses"). Deliberately its OWN small hook rather than mounting the
 * Jobs tab's full useJobsInbox() here: that hook also owns sort/search/
 * bucket-filter state and an inbox read Home has no use for (same "a
 * role-count-only read keeps the gate cheap" reasoning useOnboardingGate.ts
 * gives for not reusing useCorpusCanvas) — Home only needs the poll action +
 * its own phase/summary, so this hook is exactly that slice, reusing the
 * SAME pollWatchlist()/api.ts call and the SAME PollState/INITIAL_POLL_STATE
 * shape (re-exported from useJobsInbox.ts, not duplicated) so both surfaces
 * render identically honest, served-only PollSummary counts.
 *
 * Tap-only by design (brief: "never auto-fire the poll on mount... prefer
 * the tap") — this hook does nothing until runPollNow is called; there is no
 * mount-time useEffect here at all.
 */
export function useWelcomeBackPoll() {
  const [poll, setPoll] = useState<PollState>(INITIAL_POLL_STATE);

  const runPollNow = useCallback(async () => {
    setPoll({ phase: 'polling', summary: null, error: null });
    try {
      const { ok: _ok, ...summary } = await pollWatchlist();
      setPoll({ phase: 'done', summary, error: null });
    } catch (err) {
      setPoll({
        phase: 'error',
        summary: null,
        error: err instanceof Error ? err.message : String(err),
      });
    }
  }, []);

  return { poll, runPollNow };
}
